var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 20.92",
    id: "svg13",
    width: 22,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g13",
    transform: "translate(-6.54,-8.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    style: {
      display: "inline"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m 11.55,17.54 c 0.13,0.25 0.2,0.54 0.2,0.83 v 7.54 c 0,1 -0.81,1.81 -1.81,1.81 -1,0 -1.81,-0.81 -1.81,-1.81 v -7.54 c 0,-0.3 0.07,-0.58 0.2,-0.83 0.51,0.18 1.05,0.27 1.6,0.27 0.55,0 1.09,-0.09 1.6,-0.27 m 0.36,-1.84 c -0.55,0.38 -1.22,0.61 -1.94,0.61 -0.72,0 -1.39,-0.23 -1.94,-0.61 -0.83,0.6 -1.36,1.57 -1.36,2.67 v 7.54 c 0,1.83 1.48,3.31 3.31,3.31 v 0 c 1.83,0 3.31,-1.48 3.31,-3.31 v -7.54 c 0,-1.1 -0.54,-2.07 -1.36,-2.67 v 0 z",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m 9.95,9.81 c 1.05,0 1.91,0.86 1.91,1.91 0,1.05 -0.86,1.91 -1.91,1.91 -1.05,0 -1.91,-0.86 -1.91,-1.91 0,-1.05 0.86,-1.91 1.91,-1.91 m 0,-1.5 c -1.88,0 -3.41,1.53 -3.41,3.41 0,1.88 1.53,3.41 3.41,3.41 1.88,0 3.41,-1.53 3.41,-3.41 0,-1.88 -1.53,-3.41 -3.41,-3.41 z",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m 23.53,17.54 c 0.51,0.18 1.05,0.27 1.6,0.27 0.55,0 1.09,-0.09 1.6,-0.27 0.13,0.25 0.2,0.54 0.2,0.83 v 7.54 c 0,1 -0.81,1.81 -1.81,1.81 -1,0 -1.81,-0.81 -1.81,-1.81 v -7.54 c 0,-0.3 0.07,-0.58 0.2,-0.83 m 3.57,-1.84 c -0.55,0.38 -1.22,0.61 -1.94,0.61 -0.72,0 -1.39,-0.23 -1.94,-0.61 -0.83,0.6 -1.36,1.57 -1.36,2.67 v 7.54 c 0,1.83 1.48,3.31 3.31,3.31 v 0 c 1.83,0 3.31,-1.48 3.31,-3.31 v -7.54 c 0,-1.1 -0.54,-2.07 -1.36,-2.67 v 0 z",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m 25.13,9.81 c 1.05,0 1.91,0.86 1.91,1.91 0,1.05 -0.86,1.91 -1.91,1.91 -1.05,0 -1.91,-0.86 -1.91,-1.91 0,-1.05 0.86,-1.91 1.91,-1.91 m 0,-1.5 c -1.88,0 -3.41,1.53 -3.41,3.41 0,1.88 1.53,3.41 3.41,3.41 1.88,0 3.41,-1.53 3.41,-3.41 0,-1.88 -1.53,-3.41 -3.41,-3.41 z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m 19.14,21.24 c 0.12,0.22 0.19,0.47 0.2,0.73 0,0.02 0,0.03 0,0.05 v 3.89 c 0,1 -0.81,1.81 -1.81,1.81 -1,0 -1.81,-0.81 -1.81,-1.81 v -3.84 0 c 0,0 0,-0.04 0,-0.06 0,-0.27 0.08,-0.54 0.2,-0.77 0.51,0.18 1.05,0.27 1.6,0.27 0.55,0 1.09,-0.09 1.6,-0.27 m 0.36,-1.84 c -0.55,0.38 -1.22,0.61 -1.94,0.61 -0.72,0 -1.39,-0.23 -1.94,-0.61 -0.8,0.58 -1.33,1.51 -1.36,2.57 v 0 3.95 c 0,1.83 1.48,3.31 3.31,3.31 v 0 c 1.83,0 3.31,-1.48 3.31,-3.31 v -4.02 0 C 20.8,20.87 20.28,19.97 19.5,19.41 v 0 z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m 17.54,13.51 c 1.05,0 1.91,0.86 1.91,1.91 0,1.05 -0.86,1.91 -1.91,1.91 -1.05,0 -1.91,-0.86 -1.91,-1.91 0,-1.05 0.86,-1.91 1.91,-1.91 m 0,-1.5 c -1.88,0 -3.41,1.53 -3.41,3.41 0,1.88 1.53,3.41 3.41,3.41 1.88,0 3.41,-1.53 3.41,-3.41 0,-1.88 -1.53,-3.41 -3.41,-3.41 z",
    id: "path6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrio);
export default __webpack_public_path__ + "static/media/Trio.a5861619434e80990a0c35a57a89e560.svg";
export { ForwardRef as ReactComponent };